import React from 'react';
import s from './SuffixText.scss';

interface Props {
  children: React.ReactNode;
}

const SuffixText: React.FC<Props> = ({ children }) => <span className={s['root']}>{children}</span>;

SuffixText.displayName = 'SuffixText';

export default SuffixText;
